function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { AddIcon, DreamhomeOutlineIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button, Heading, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { useFollowedProperties, useMyFollowedPropertyDialogs, MyFollowedPropertyDialogs } from '@domain-group/fe-co-allhomes-followed-properties-dialogs';
import * as styles from './followed-property.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FollowedProperty = _ref => {
  var addressId = _ref.addressId,
    followedPropertiesUrl = _ref.followedPropertiesUrl;
  var _useFollowedPropertie = useFollowedProperties(),
    isFollowedProperty = _useFollowedPropertie.isFollowedProperty;
  var _useMyFollowedPropert = useMyFollowedPropertyDialogs(),
    openFollowThisProperty = _useMyFollowedPropert.openFollowThisProperty,
    myFollowedPropertyDialogProps = _useMyFollowedPropert.myFollowedPropertyDialogProps;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visibilityEventSent = _useState2[0],
    setVisibilityEventSent = _useState2[1];
  var isFollowed = isFollowedProperty(addressId);
  var handleClick = () => {
    sendEvent('follow-property-click');
    openFollowThisProperty(addressId);
  };
  return ___EmotionJSX("div", {
    css: styles.followedProperty
  }, ___EmotionJSX(Heading, {
    title: "Want to keep tabs on this property?"
  }), ___EmotionJSX("div", {
    css: styles.text
  }, isFollowed ? ___EmotionJSX("span", null, "You've already added this property.") : ___EmotionJSX(Fragment, null, ___EmotionJSX("span", null, "Add this property to track how much it's worth and keep up to date with local market activity in your area.", ' '), ___EmotionJSX("a", {
    css: styles.link,
    href: followedPropertiesUrl
  }, "Know more about 'My properties'."))), isFollowed ? ___EmotionJSX(LinkButton, {
    css: styles.button,
    appearance: "outline",
    href: followedPropertiesUrl
  }, ___EmotionJSX(DreamhomeOutlineIcon, null), ___EmotionJSX("span", {
    css: styles.buttonText
  }, "View all your properties")) : ___EmotionJSX(Fragment, null, ___EmotionJSX(VisibilitySensor, {
    onChange: isVisible => {
      if (isVisible && !visibilityEventSent) {
        sendEvent('display-my-followed-property');
        setVisibilityEventSent(true);
      }
    }
  }, ___EmotionJSX(Button, {
    css: styles.button,
    appearance: "outline",
    onClick: handleClick
  }, ___EmotionJSX(AddIcon, null), ___EmotionJSX("span", {
    css: styles.buttonText
  }, "Add this property"))), ___EmotionJSX(MyFollowedPropertyDialogs, myFollowedPropertyDialogProps)));
};
FollowedProperty.propTypes = {
  addressId: PropTypes.string.isRequired,
  followedPropertiesUrl: PropTypes.string
};
FollowedProperty.defaultProps = {
  followedPropertiesUrl: ''
};
export default FollowedProperty;